/**
 * Browser-compatible shim for api/http-library.js
 *
 * The original uses Node's built-in `http` module (server-side only).
 * This shim reimplements the same `request()` interface using fetch.
 */

export const request = function (providedRequestParams, callback, optionalBody) {
  const requestParams = providedRequestParams;
  const method = requestParams.method || "GET";

  if (-1 === ["GET", "PUT", "POST", "DELETE"].indexOf(method)) {
    throw new Error(
      "requestParams.method value was " +
        method +
        " , but must be one of 'GET', 'PUT', 'POST', 'DELETE'",
    );
  }

  let postBody;
  if (optionalBody) {
    try {
      const unsanitizedBody = JSON.stringify(optionalBody);
      postBody = unsanitizedBody.replace(/(<([^>]+)>)/gi, "");
    } catch (e) {
      throw new Error(
        "optionalBody was provided, but errored when stringified: " + e,
      );
    }
  }

  let path = requestParams.path;
  if (-1 === path.indexOf("?")) {
    path += "?timestamp=" + Date.now();
  }

  // Build full URL: if host is provided and path is relative, join them.
  // The host may include protocol (http://...) or be a bare hostname.
  let url;
  if (requestParams.host) {
    const host = requestParams.host.replace(/\/$/, "");
    url = host + path;
  } else {
    url = path;
  }

  const headers = {
    Accept: "application/json",
    "Cache-Control": "no-cache, must-revalidate",
    Pragma: "no-cache",
    ...(requestParams.headers || {}),
  };
  if (postBody) {
    headers["Content-Type"] = "application/json";
  }

  const fetchOptions = {
    method,
    headers,
  };
  if (postBody) {
    fetchOptions.body = postBody;
  }

  fetch(url, fetchOptions)
    .then((response) => {
      const statusCode = response.status;
      return response.text().then((text) => {
        let responseObject;
        try {
          responseObject = JSON.parse(text);
          responseObject.statusCode = statusCode;
          if (
            399 < statusCode &&
            "object" === typeof analyticsIntegrations
          ) {
            if (-1 === ["PUT", "POST"].indexOf(method)) {
              analyticsIntegrations.formFail(path, text);
            } else if ("GET" === method) {
              analyticsIntegrations.requestFail(path, text);
            }
          }
        } catch (e) {
          responseObject = { error: "Invalid JSON", responseData: text, statusCode };
        }
        return responseObject;
      });
    })
    .then(
      (responseObject) => callback(responseObject),
      (e) => callback({ error: e.message })
    );
};
